import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetAllSampleCards, apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './ExportRecepturPage.css';
import { apiExportReceiptsCsv } from "../services/ExportReceipts";
import { useTranslation } from "react-i18next";

interface Props {
    contextLevel: string;

}

const ExportRecepturPage = (props: Props) => {

    let initFormDataState: any =
    {
        'entireSampleCard': false,
        'allSampleCards': false,
        pigmentsRatio: 100,
        sampleCardId: null,
        targetProductIds: [],
        targetProductsAsText: '',
        targetProductsIdsAsText: '',
        pigmentsUnit: 11,
        baseUnit: 11
    };

    const { t } = useTranslation(undefined);


    const [formData, setFormData] = useState(initFormDataState);
    const [sampleCardsForProduct, setSampleCardsForProduct] = useState([]);
    const [allTargetProducts, setAllTargetProducts] = useState([]);
    const productInfo = useSelector((state: any) => state.productInfo);
    const dispatch = useDispatch();

    useEffect(() => {

        loadData();

    }, []);

    const loadData = async () => {

        let sampleCards: any = await loadSampleCards();
        loadProducts();

        if (sampleCards && sampleCards.length > 0) {
            setFormData({ ...formData, sampleCardId: sampleCards[0].id })
        }
    }


    const loadSampleCards = async () => {

        let sampleCards = await apiGetAllSampleCards();
        setSampleCardsForProduct(sampleCards.data);

        return sampleCards.data;
    }

    const loadProducts = async () => {

        let allProducts = await apiGetAllProducts(false);

        setAllTargetProducts(allProducts.data);
    }

    const handleSampleCardAllCheckedChange = async (checked) => {

        setFormData({ ...formData, allSampleCards: checked });

    }

    const handleSampleCardChange = async (id) => {

        setFormData({ ...formData, sampleCardId: id });

    }

    const handleTargetProductChange = (selectedOptions) => {

        let displayText = '';
        let idsAsText = '';

        if (selectedOptions && selectedOptions.length > 0) {
            let allSelectedLabels: any[] = [];
            let allSelectedIds: any[] = [];

            selectedOptions.forEach((option: any) => {
                allSelectedLabels.push(option.label);
                allSelectedIds.push(option.value);
            }
            );

            idsAsText = allSelectedIds.join('#');
            displayText = allSelectedLabels.join(', ');
        }

        setFormData({
            ...formData,
            targetProductIds: selectedOptions,
            targetProductsAsText: displayText,
            targetProductsIdsAsText: idsAsText
        });
    }

    const handleUnitChangeBasis = (id) => {
        setFormData({ ...formData, baseUnit: id });
    }

    const handleUnitChangePigments = (id) => {
        setFormData({ ...formData, pigmentsUnit: id });
    }

    const handleExportCreation = async () => {
   
        if (!formData.targetProductsIdsAsText || formData.targetProductsIdsAsText.length <= 0) {
            alert(t('ExportReceipts.PleaseSelectAtLeastOneProduct'));
            return;
        }

        if (!formData.sampleCardId && !formData.allSampleCards) {
            alert(t('ExportReceipts.PleaseSelectSampleBook'));
            return;
        }

        await apiExportReceiptsCsv(
            formData.targetProductsIdsAsText,
            formData.sampleCardId,
            formData.allSampleCards,
            formData.pigmentsUnit,
            formData.baseUnit)
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', t('ExportReceipts.ExportFilenameCsv')); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            });
    };

    const productsOptions = allTargetProducts.map((product: any) => {
        return { 'label': product.name, 'value': product.id }
    });

    return <>
        <PageContent>
            <>
                <TopBarWithBreadCrumb
                    contextLevel={props.contextLevel}
                    pageLevel="Receptury"
                />

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-6">
                        <div className={`card`}>

                            <div className="card-body">

                                <MultiSelect
                                    options={productsOptions}
                                    value={formData.targetProductIds}

                                    onChange={handleTargetProductChange}
                                    labelledBy={t('ExportReceipts.Products')}
                                    overrideStrings={{
                                        "allItemsAreSelected": t('ExportReceipts.Products'),
                                        "clearSearch": t('ExportReceipts.clearSearch'),
                                        "clearSelected": t('ExportReceipts.clearSelected'),
                                        "noOptions": t('ExportReceipts.noOptions'),
                                        "search": t('ExportReceipts.search'),
                                        "selectAll": t('ExportReceipts.selectAll'),
                                        "selectAllFiltered": t('ExportReceipts.selectAllFiltered'),
                                        "selectSomeItems": t('ExportReceipts.selectSomeItems'),
                                        "create": t('ExportReceipts.create'),
                                    }}
                                />

                                {formData.targetProductIds && formData.targetProductIds.length > 0 && <div style={{ marginBottom: '10px' }}>{formData.targetProductsAsText}</div>}
                                {!formData.targetProductIds || !formData.targetProductIds.length && <div style={{ textAlign: 'center', marginBottom: '10px' }}>Není vybrán žádný výrobek</div>}


                                <CheckBox
                                    id="allSampleCards"
                                    label="Všechny vzorkovnice"
                                    defaultValue={formData.allSampleCards}
                                    handleCheckedChange={handleSampleCardAllCheckedChange}
                                />
                                {!formData.allSampleCards &&
                                    <ComboBoxData
                                        id="sampleCards"
                                        label={t('General.Fields.SampleBook')}
                                        dataTextField="name"
                                        dataValueField="id"
                                        value={formData.sampleCardId}
                                        handleChange={handleSampleCardChange}
                                        rows={sampleCardsForProduct}
                                    />
                                }

                                <ComboBoxData
                                    id="unitSelectionBasis"
                                    label={t('General.Fields.UnitOfBase')}
                                    dataTextField="name"
                                    dataValueField="id"
                                    defaultValue={"11"}
                                    handleChange={handleUnitChangeBasis}
                                    rows={[
                                        { name: t("General.Units.Kilograms"), id: "10", code: "Kg" },
                                        { name: t("General.Units.Grams"), id: "11", code: "G" },
                                        { name: t("General.Units.Liters"), id: "21", code: "L" },
                                        { name: t("General.Units.Milliliters"), id: "22", code: "Ml" },
                                        { name: t("General.Units.Ounces"), id: "30", code: "Oz" },
                                    ]}
                                />


                                <ComboBoxData
                                    id="unitSelectionPigments"
                                    label={t('General.Fields.UnitOfPigment')}
                                    dataTextField="name"
                                    dataValueField="id"
                                    defaultValue={"11"}
                                    handleChange={handleUnitChangePigments}
                                    rows={[
                                        { name: t("General.Units.Kilograms"), id: "10", code: "Kg" },
                                        { name: t("General.Units.Grams"), id: "11", code: "G" },
                                        { name: t("General.Units.Liters"), id: "21", code: "L" },
                                        { name: t("General.Units.Milliliters"), id: "22", code: "Ml" },
                                        { name: t("General.Units.Ounces"), id: "30", code: "Oz" },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>

                </div>


                <div className="row" style={{ padding: '20px', justifyContent: 'center' }}>
                    <div className="col-4" style={{ textAlign: 'center' }}>
                        <button
                            style={{ width: '100%' }}
                            onClick={() => {
                                handleExportCreation();
                            }}
                            type="button"
                            className="btn-sm btn-primary"
                        >
                            {t('ExportReceipts.ButtonExport')}
                        </button>
                    </div>
                </div>

            </>
        </PageContent>
    </>
}

export default ExportRecepturPage;